/* WoolAffair / Dawn: opt in using product tag easify-color-gallery. */
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      if (this.dataset.waEnabled === 'true') this.waInit();
      if (!this.elements.thumbnails) return;
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
        item.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, item.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    waHydrate(root) {
      if (!root) return;
      const images = root.matches?.('img') ? [root] : root.querySelectorAll('img');
      images.forEach((image) => {
        // Set responsive candidates before src to avoid a redundant large download.
        if (image.dataset.waSrcset) {
          image.setAttribute('srcset', image.dataset.waSrcset);
          delete image.dataset.waSrcset;
        }
        if (image.dataset.waSrc) {
          image.setAttribute('src', image.dataset.waSrc);
          delete image.dataset.waSrc;
        }
      });
    }

    waReveal(activeMedia) {
      if (this.dataset.waEnabled !== 'true' || !activeMedia) return;
      const id = activeMedia.dataset.mediaId;
      if (activeMedia.hasAttribute('data-wa-color')) this.waSelectedId = id;
      this.elements.viewer.querySelectorAll('.product__media-item[data-wa-color]').forEach((item) => {
        item.hidden = item.dataset.mediaId !== this.waSelectedId;
      });
      activeMedia.hidden = false;
      this.waHydrate(activeMedia);
      this.elements.thumbnails?.querySelectorAll('[data-wa-color]').forEach((item) => {
        item.hidden = item.dataset.target !== this.waSelectedId;
        if (!item.hidden) this.waHydrate(item);
      });
      this.elements.viewer.resetPages?.();
      this.elements.thumbnails?.resetPages?.();
    }

    waInit() {
      // Keep hidden images in the DOM: Easify needs their alt text to find a match.
      this.waReveal(this.elements.viewer.querySelector('.product__media-item.is-active') ||
        this.elements.viewer.querySelector('.product__media-item:not([data-wa-color])'));
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-target]');
        if (thumbnail && this.contains(thumbnail)) {
          const media = this.elements.viewer.querySelector(`[data-media-id="${thumbnail.dataset.target}"]`);
          this.waReveal(media);
        }
        const toggle = event.target.closest('.product__media-toggle');
        if (!toggle) return;
        const opener = toggle.closest('modal-opener');
        const modal = document.querySelector(opener?.dataset.modal || '#wa-no-modal');
        if (!modal) return;
        const activeMedia = toggle.closest('.product__media-item');
        this.waReveal(activeMedia);
        modal.querySelectorAll('img[data-wa-color]').forEach((image) => {
          const selected = this.elements.viewer.querySelector(`[data-media-id="${this.waSelectedId}"]`);
          image.hidden = image.dataset.mediaId !== selected?.querySelector('.product__media-toggle')?.dataset.mediaId;
          if (!image.hidden) this.waHydrate(image);
        });
      }, true);
      // Easify can select a thumbnail or mark a gallery item itself.
      this.waObserver = new MutationObserver((records) => {
        for (const record of records) {
          const item = record.target;
          if (!item.matches?.('.product__media-item[data-media-id]')) continue;
          const oldClasses = (record.oldValue || '').split(/\s+/);
          const easifySelected = item.classList.contains('tpo-isactive-image') && !oldClasses.includes('tpo-isactive-image');
          const dawnSelected = item.classList.contains('is-active') && !oldClasses.includes('is-active');
          if (easifySelected || dawnSelected) this.waReveal(item);
        }
      });
      this.waObserver.observe(this.elements.viewer, {
        subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true,
      });
    }

    onSlideChanged(event) {
      const media = event.detail.currentElement;
      // Swiping through ordinary images must not deselect the Easify color.
      if (this.dataset.waEnabled === 'true') this.waHydrate(media);
      const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${media.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
        this.elements.viewer.querySelector('[data-media-id]');
      if (!activeMedia) return;
      this.waReveal(activeMedia);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('is-active'));
      activeMedia.classList.add('is-active');
      if (prepend) {
        if (activeMedia.parentElement.firstChild !== activeMedia) activeMedia.parentElement.prepend(activeMedia);
        const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        if (thumbnail && thumbnail.parentElement.firstChild !== thumbnail) thumbnail.parentElement.prepend(thumbnail);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (!this.mql.matches || this.elements.thumbnails) activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        const rect = activeMedia.getBoundingClientRect();
        if (rect.top > -0.5) return;
        window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
      });
      this.playActiveMedia(activeMedia);
      const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
      if (thumbnail) this.announceLiveRegion(activeMedia, thumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', 'true');
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      const announce = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
        setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
      };
      if (image.complete && image.naturalWidth) announce();
      else image.addEventListener('load', announce, { once: true });
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      activeItem.querySelector('.deferred-media')?.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
    }
  });
}
